/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Paste_AttributesInputs */



/**
* | output |
* | --- |
* | "Paste Attributes..." |
*
* @param {Context_Menu_Paste_AttributesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_paste_attributes = /** @type {((inputs?: Context_Menu_Paste_AttributesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Paste_AttributesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller les attributs...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Attribute einfügen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incolla attributi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить атрибуты...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pegar atributos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴属性...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("属性を貼り付け...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विशेषताएँ पेस्ट करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colar atributos...")
	return /** @type {LocalizedString} */ ("Paste Attributes...")
});